(function(window, document) {
    'use strict'

    function waitForPersistence(promise) {
        return Promise.race([
            Promise.resolve(promise).catch(function() {
                return false
            }),
            new Promise(function(resolve) {
                setTimeout(function() {
                    resolve(false)
                }, window.RTAnalyticsInternal.config.navigationWaitMs)
            })
        ])
    }

    document.addEventListener('click', function(event) {
        if (!event.target || typeof event.target.closest !== 'function') {
            return
        }

        const button = event.target.closest('[data-analytics-event="click2pay"]')
        if (!button) {
            return
        }

        if (button.dataset.analyticsProcessing === 'true') {
            event.preventDefault()
            return
        }

        event.preventDefault()
        button.dataset.analyticsProcessing = 'true'

        const link = button.getAttribute('href')
        const ticket = window.RT.analytics.track('certificates.clickToPay')

        waitForPersistence(ticket.persisted).then(function() {
            if (link) {
                window.location.href = link
                return
            }

            button.dataset.analyticsProcessing = 'false'
        })
    })
})(window, document)
